import { TILE_MIN_SIZE, type AuftragsTypOption } from '@/lib/kiosk-flow';

interface Props {
  option: AuftragsTypOption;
  selected: boolean;
  onSelect: () => void;
}

export function AuftragsTypTile({ option, selected, onSelect }: Props) {
  return (
    <button
      onClick={onSelect}
      data-testid={`tile-${option.id}`}
      style={{
        minWidth: TILE_MIN_SIZE,
        minHeight: TILE_MIN_SIZE,
        borderColor: selected ? option.color : '#E5E7EB',
        backgroundColor: selected ? option.bgColor : '#FFFFFF',
        boxShadow: selected ? `0 0 0 3px ${option.color}33` : undefined,
      }}
      className="flex flex-col items-center justify-center gap-4 rounded-3xl border-2 p-8 text-center transition-all hover:shadow-lg focus:outline-none active:scale-[0.98]"
    >
      <span className="text-6xl leading-none select-none">{option.emoji}</span>
      <div>
        <p
          className="text-[20px] font-bold leading-tight"
          style={{ color: selected ? option.color : '#111827' }}
        >
          {option.label}
        </p>
        <p className="mt-1 text-[13px] text-gray-500 leading-snug max-w-[200px]">
          {option.beschreibung}
        </p>
      </div>
      {selected && (
        <div
          className="w-7 h-7 rounded-full flex items-center justify-center"
          style={{ backgroundColor: option.color }}
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M2.5 7L5.5 10L11.5 4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      )}
    </button>
  );
}
